import Vue from "vue";
const vueInstance = new Vue();

const speech = {
  synth: null,
  utter: null,
  voices: [],
  voice: 0,
  speed: 2.0,
  texto: "",
  speaking: false,

  init() {
    if (window.speechSynthesis) {
        this.synth = window.speechSynthesis;
        this.utter = new SpeechSynthesisUtterance("");
        this.voices = this.synth.getVoices() || [];
        this.voice = this.voices.findIndex((v) => v.default) || 0;
    } 
  },
  speechVoices() {
    return this.voices.map((v, i) => ({ value: i, text: v.name }));
  },
  vspeek() {
    return this.synth && this.texto !== "" && !this.speaking ? true : false;
  },
  speak(texto, voiceindex = 0, speed = 1.0) {
    this.speaking = true;
    vueInstance.$emit("speaking", true);
    if (this.synth.speaking) return;
    
    if (texto == "") texto = this.texto;
    //console.log('speech.texto:', texto);

    if (this.synth) {
      const voice = this.voices[voiceindex || this.voice];
      //this.voices = this.synth.getVoices();
      if (texto !== "") {
        this.utter = new SpeechSynthesisUtterance(texto);
        this.utter.voice = voice;
        this.utter.rate = speed;
        this.utter.onend = () => {
          this.speaking = false;
          vueInstance.$emit("speaking", false);
        };
        this.synth.speak(this.utter);
      }
    }
  },
  setVoice() {
    if (this.synth && !this.voices) {
      this.voices = this.synth.getVoices();
    }
    this.voice = this.voices.findIndex((v) => v.lang === "pt-BR");
  },
  getVoices() {
    if (this.synth && !this.voices) {
      this.voices = this.synth.getVoices();
    }
    return this.voices;
  },
  getOptionsVoices() {
    if (this.synth && !this.voices) {
      this.voices = this.synth.getVoices();
    }
    return this.voices.map((v,i)=>({value:i,text:v.name}));
  },
  getSpeed() {
    return this.speed;
  }
}

speech.init();

export default speech;